export const api = "/api/v1";
export const turn = "turn:defender.aplit.tech:3479";
export const cryptoTurn = "turn:127.0.0.1:22345?transport=tcp";
export const localCrypterIp = "http://127.0.0.1:22346";
export const localCrypterIp_IOS = "https://loopback.aplit.tech:22346";
